<template>
  <v-footer v-if="isOutsider || showSharedWarning" app class="ec-footer shared-camp">
    <p class="mb-0">
      <v-icon start size="small" class="currentColor--text">mdi-earth</v-icon>
      <strong>{{ $t(`components.camp.footerSharedCamp.${key}`) }}</strong>
      {{ $t(`components.camp.footerSharedCamp.${key}Description`) }}
    </p>
  </v-footer>
</template>

<script>
import { campFromRoute } from '@/router.js'
import { campRoleMixin } from '@/mixins/campRoleMixin.js'

export default {
  name: 'FooterSharedCamp',
  mixins: [campRoleMixin],
  computed: {
    camp() {
      return campFromRoute(this.$route)
    },
    key() {
      return this.isOutsider ? 'outsider' : this.showSharedWarning ? 'shared' : ''
    },
    showSharedWarning() {
      // The warning is intended for people with write access to the camp,
      // so that they know that the data they enter is publicly accessible.
      return this.camp?.isShared && !this.isOutsider && !this.isGuest
    },
  },
}
</script>

<style scoped>
/* <v-footer> is transformed to <footer class="v-footer"> */
/* eslint-disable-next-line vue-scoped-css/no-unused-selector */
.v-footer.shared-camp {
  border-color: #c8930d;
  background: #fbf0df;
  color: #7a4f0f;
}

/* eslint-disable-next-line vue-scoped-css/no-unused-selector */
.v-icon {
  margin-top: -2px;
}
</style>
